import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconDotsSizeS from './IconDots_size_s';

const props: CreateIconArguments = {
  l: IconDotsSizeS,
  m: IconDotsSizeS,
  s: IconDotsSizeS,
  xs: IconDotsSizeS,
  name: 'IconDots',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'mono',
};

export default props;
